import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const sendWelcomeEmail = createServerFn({ method: "POST" })
  .validator((input) => z.object({ force: z.boolean().optional() }).parse(input ?? {}))
  .handler(async ({ data }) => {
    try {
      const { getOptionalAuth } = await import("@/lib/optional-auth.server");
      const auth = await getOptionalAuth();
      if (!auth) return { ok: false as const, skipped: true as const, reason: "no_session" as const };

      const { runSendWelcomeEmail } = await import("@/lib/welcome-email.server");
      return await runSendWelcomeEmail(auth.userId, Boolean(data.force));
    } catch (error) {
      // This call is a best-effort post-sign-in nudge. Email or backend
      // availability must never turn a successful sign-in into a 500 page.
      console.error("[welcome-email] best-effort send failed", error);
      return { ok: false as const, skipped: true as const, reason: "temporarily_unavailable" as const };
    }
  });

export const adminSendWelcomeEmail = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .validator((input) => z.object({ user_id: z.string().uuid() }).parse(input))
  .handler(async ({ data, context }) => {
    const { runAdminSendWelcomeEmail } = await import("@/lib/welcome-email.server");
    return runAdminSendWelcomeEmail(context.supabase, context.userId, data.user_id);
  });
